/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_112Inputs */

const cs_ares_legal_form_112 = /** @type {(inputs: Ares_Legal_Form_112Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Společnost s ručením omezeným`)
};

const en_ares_legal_form_112 = /** @type {(inputs: Ares_Legal_Form_112Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited liability company`)
};

/**
* | output |
* | --- |
* | "Limited liability company" |
*
* @param {Ares_Legal_Form_112Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_112 = /** @type {((inputs?: Ares_Legal_Form_112Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_112Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_112(inputs)
	return cs_ares_legal_form_112(inputs)
});